import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

// import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import Layout from '../components/layout'
import Head from '../components/head'
import Hero from '../components/Hero'
import SectionPictos from '../components/sectionPictos'
import SectionTextImage from '../components/sectionTextImage'
import SectionHighlights from '../components/sectionHiglights'
import SectionBestSellers from '../components/sectionBestSellers'
import Form from '../components/form'

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulPageDaccueil {
        titre
        metaDescription
        metaTitle
        image {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        sectionPictosTitle
        sectionPictosText {
          sectionPictosText
        }
        aboutSectionTitle
        aboutSectionText {
          aboutSectionText
        }
        aboutSectionImage {
          fluid(maxHeight: 400) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <Head
        title={data.contentfulPageDaccueil.metaTitle}
        description={data.contentfulPageDaccueil.metaDescription}
      />
      <div className="full-width">
        <Hero
          className="hero"
          imageData={data.contentfulPageDaccueil.image.fluid}
          title={data.contentfulPageDaccueil.titre}
        />
      </div>
      <SectionPictos
        title={data.contentfulPageDaccueil.sectionPictosTitle}
        text={data.contentfulPageDaccueil.sectionPictosText.sectionPictosText}
      />
      <SectionTextImage
        fluid={data.contentfulPageDaccueil.aboutSectionImage.fluid}
        title={data.contentfulPageDaccueil.aboutSectionTitle}
        text={data.contentfulPageDaccueil.aboutSectionText.aboutSectionText}
        bg="bg-light"
        linkText="En savoir plus"
        linkSlug="a-propos"
      />
      <SectionHighlights />
      <SectionBestSellers />

      <Form title="Une question ? Contactez-nous" />
    </Layout>
  )
}

export default IndexPage
